"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormContext = void 0;
const React = require("react");
exports.FormContext = React.createContext({
    setFieldValue: () => {
        throw new Error("setFieldValue not handled");
    },
    clearFieldValue: () => {
        throw new Error("clearFieldValue not handled");
    },
    newGroupInstance: () => {
        throw new Error("newGroupInstance not handled");
    },
    removeGroupInstance: () => {
        throw new Error("removeGroupInstance not handled");
    }
});
//# sourceMappingURL=formContext.js.map